import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { TestSessionSummary } from "@school-sales-ai/shared";
import { api } from "@/lib/api";

// List/rename/delete of "Probar Agente" test sessions (real isTest leads).
// Creation happens inside useTestAgent (lazily, on first send) so the list
// never fills with empty conversations.

export function useTestSessions() {
  return useQuery({
    queryKey: ["test-sessions"],
    queryFn: () => api.get<TestSessionSummary[]>("/crm/test-agent/sessions"),
  });
}

export function useRenameTestSession() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, label }: { id: string; label: string }) =>
      api.patch<{ id: string; testLabel: string | null }>(
        `/crm/test-agent/sessions/${id}`,
        { label },
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["test-sessions"] });
    },
  });
}

export function useDeleteTestSession() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      api.delete<void>(`/crm/test-agent/sessions/${id}`),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["test-sessions"] });
    },
  });
}
